import React from 'react';
import { compose } from 'ramda';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { PCI_URL, PCI_VERSION, PCI_VERSION_ST } from '../../../config/constants';
import styleFile from '../../../views/customerForm/CustomerForm.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { connect } from 'react-redux';
import { STAR_TRAVELER_CODE } from '@synergycms_app/store/customer/loyaltyActions';


const mapStateToProps = store => {
  return {
    location: btoa(window.location.href),
    loyaltyUser: store.getIn(['customer', 'loyalty','user',"user_id"], null) && store.getIn(['customer', 'loyalty','user'], null),
    loyaltyType : store.getIn(["customer", "loyalty", "data", "loyalty", "code"],null),
  };
};

export default compose(
  connect(mapStateToProps),
  PropertyManager([
    'setRef',
    'langCode',
    'trackingId',
    'tmsTracking',
    'hotelCode',
    'checkinPCI',
    'checkoutPCI',
    'showCVC',
    'cardVerification',
    'cfees15d',
    'tpvEnabled',
    'withCof',
    'fromTms',
    'prepaymentID',
    'location',
    'loyaltyUser',
    'loyaltyType',
    'cardTokenId',
    'requiredPrepayment',
    'hideText'
  ]),
  withThemeJSS({ styleFile, link: true, displayName: 'PciFrame' })
)(
  class PciFrame extends React.Component {
    onload = () => {
      this.pciFrame && this.pciFrame.contentWindow.postMessage('set_origin_source', PCI_URL);
    };

    render() {
      const { config, theme } = this.props;
      const { classes } = theme.styles;
      const { loyaltyUser, loyaltyType, location } = config;
      const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;

      return (
        <iframe
          ref={ref => {
            config.setRef(ref);
            this.pciFrame = ref;
          }}
          onLoad={this.onload}
          className={classes.pciFrame}
          scrolling={'no'}
          src={
            PCI_URL +
            '/CardsApp/BookingProcess?lang=' +
            config.langCode +
            '&version=' +
            (UserLoggedST ? PCI_VERSION_ST : PCI_VERSION) +
            '&tracking_id=' +
            config.trackingId +
            '&hotel_id=' +
            config.hotelCode +
            '&checkin=' +
            config.checkinPCI +
            '&checkout=' +
            config.checkoutPCI +
            '&validate_cvc=' +
            config.showCVC +
            (config.cardTokenId ? '&token_id=' + config.cardTokenId : '') +
            (process.env.NODE_ENV !== 'production' ? '&test=1' : '') +
            '&cfees15d=' +
            (config.cfees15d && config.cardVerification && !config.withCof ? 1 : 0) +
            '&cof=' +
            (config.withCof ? 1 : 0) +
            '&from_tms=' +
            (config.fromTms ? 1 : 0) +
            '&prepay=' +
            (config.requiredPrepayment) +
            '&tpv=' +
            config.tpvEnabled +
            '&location=' +
            location +
            (config.hideText ? '&hideText=1' : '') +
            (UserLoggedST ? '&log_type=loyalty' : '') +
            (UserLoggedST ? '&log_user=' + loyaltyUser.get('user_id', '') : '') +
            (UserLoggedST ? '&log_token=' + loyaltyUser.get('token', '') : '') +
            (config.tmsTracking ? ('&tms_tracking=' + config.tmsTracking) : '') +
            (config.prepaymentID ? ('&prepayment_id=' + config.prepaymentID) : '')
          }
          title={'Credit Card Frame'}
          frameBorder={'0'}
        />
      );
    }
  }
);
